var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.notifications),function(notification){return _c('item',{key:notification.id,attrs:{"notification":notification,"collapsed":_vm.collapsed}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }